import { useCombobox } from "downshift";
import { findNextValidOptionIndex } from "../utils";

/**
 * StateReducer for SelectComboBox and MultiSelectComboBox for when highlightFirstOptionAutomatically is true.
 */
export const highlightFirstAutomaticallyStateReducer = (options, currentState, actionsAndChanges) => {
  const {
    changes,
    type
  } = actionsAndChanges;
  switch (type) {
    case useCombobox.stateChangeTypes.FunctionToggleMenu:
      if (!currentState.isOpen && changes.isOpen === true) {
        return {
          ...changes,
          highlightedIndex: findNextValidOptionIndex(options)
        };
      }
      break;
    case useCombobox.stateChangeTypes.ToggleButtonClick:
      // if the menu is opening
      if (!currentState.isOpen && changes.isOpen === true) {
        return {
          ...changes,
          highlightedIndex: findNextValidOptionIndex(options)
        };
      }
      break;
  }
  return changes;
};
//# sourceMappingURL=highlightFirstAutomaticallyStateReducer.js.map